import {h, Fragment} from "preact"
export default function Select({ value, onChange, className, options }) {
    return (
        <div className="ns-relative ns-sort-container">
            <select
                className={`ns-selection-dropdown-menu ns-text-align-center ${className}`}
                value={value}
                onChange={onChange}
            >
                {options.map(option => (
                    <option class="ns-sort-variant" key={option.value} value={option.value} style={{backgroundColor:"#fbf9f5", boxShadow:"0 4px 12px #2125291f, 0 0 1px #21252952"}}>
                        {option.label}
                    </option>
                ))}
            </select>
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret icon ns-sort-icon" viewBox="0 0 10 6">
                <title>Caret</title>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
            </svg>
        </div>

        // <div class="disclosure">
        //     <ul id="sortby" role="list" class="disclosure__list" hidden="true">
        //         {options.map(option => (
        //             <li class="disclosure__item" key={option.value} value={option.value}>
        //                 <a href="#" aria-current="true" data-value={option.value}>
        //                     {option.label}
        //                 </a>
        //             </li>
        //         ))}
        //         <li class="disclosure__item disclosure__item--current " tabindex="-1">
        //             <a href="#" aria-current="true" data-value="relevance">
        //                 Relevance
        //             </a>
        //             <svg class="icon icon-tick icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="graphics-symbol" focusable="false">
        //                 <title>Tick</title>
        //                 <path d="M5 13L9 17L19 7" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
        //             </svg>
        //         </li>
        //         <li class="disclosure__item " tabindex="-1">
        //             <a href="#" data-value="price-ascending">
        //                 Price, low to high
        //             </a>
        //             <svg class="icon icon-tick icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="graphics-symbol" focusable="false">
        //                 <title>Tick</title>
        //                 <path d="M5 13L9 17L19 7" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
        //             </svg>
        //         </li>
        //         <li class="disclosure__item " tabindex="-1">
        //             <a href="#" data-value="price-descending">
        //                 Price, high to low
        //             </a>
        //             <svg class="icon icon-tick icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="graphics-symbol" focusable="false">
        //                 <title>Tick</title>
        //                 <path d="M5 13L9 17L19 7" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
        //             </svg>
        //         </li>
        //     </ul>
        //     <button type="button" class="disclosure__button" aria-expanded="false" aria-controls="sortby">
        //         <span class="disclosure__button_text custom">
        //             Relevance
        //         </span>
        //         <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret icon" viewBox="0 0 10 6">
        //             <title>Caret</title>
        //             <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
        //         </svg>
        //     </button>
        //     {/* <input @change="currentSort = $el.value" type="hidden" name="sortby-value" value=""> */}
        // </div>
    )
}